import { css } from "@emotion/react";

export const SwiperVipDetailsMStyle = {
  wrapper: css`
    padding: 5px 0;
    .swiper-slide {
      .member-vip__data {
        span {
          display: none;
        }
      }
      &-active {
        transform: translateY(20px) scale(1.08);
        .member-vip__data {
          span {
            display: block;
          }
        }
      }
    }
  `,
};
